import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { useFetchTransactionBreakdownByType } from "@transactionHooks";
import { ReportProps } from "../common.props";
import CategoryBreakdownRow from "./CategoryBreakdownRow";

const COLORS = [
  "#6366f1",
  "#f59e0b",
  "#10b981",
  "#ef4444",
  "#3b82f6",
  "#8b5cf6",
  "#ec4899",
];

export function CategoryBreakdownPanel({
  displayCurrency,
  convert,
}: ReportProps) {
  const { data, isLoading } = useFetchTransactionBreakdownByType("expense");

  const chartData = (data ?? []).map((cat) => ({
    name: cat.categoryName,
    value: cat.total,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Expense Breakdown by Category</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && (
          <p className="text-sm text-muted-foreground">Loading...</p>
        )}

        {!isLoading && (
          <div className="flex flex-col lg:flex-row gap-6">
            <div className="flex-1">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Category</TableHead>
                    <TableHead>Currency</TableHead>
                    <TableHead className="text-right">Amount</TableHead>
                    <TableHead className="text-right">%</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {(data ?? []).map((cat, i) => (
                    <CategoryBreakdownRow
                      key={cat.categoryId}
                      cat={cat}
                      displayCurrency={displayCurrency}
                      convert={convert}
                    />
                  ))}
                </TableBody>
              </Table>
            </div>

            {chartData.length > 0 && (
              <div className="w-full lg:w-64 h-64">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={chartData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      innerRadius={50}
                      outerRadius={90}>
                      {chartData.map((_, i) => (
                        <Cell key={i} fill={COLORS[i % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip formatter={(v: number) => v.toFixed(2)} />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
